export type ServiceType = string;

export enum MachineStatus {
  ONLINE = "online",
  OFFLINE = "offline",
  CLOSED = "closed",
  MAINTENANCE = "maintenance"
}

export enum ServiceMode {
  UNIVERSAL = "universal",
  ONLINE_ONLY = "online_only",
  OFFLINE_ONLY = "offline_only"
}
